export class WorkQueueActionParametersDto {
    workQueueId: string;
    action: string;
    userId: string;
    emailJobId: string;

    getQueryString(): string {
        const tokens: string[] = [];

        tokens.push(`workQueueId=${this.workQueueId}`);
        tokens.push(`action=${this.action}`);
        tokens.push(`userId=${this.userId}`);
        tokens.push(`emailJobId=${this.emailJobId}`);

        return `?${tokens.join('&')}`;
    }
}
